<ul>
  <li *ngFor="let product of products">
    <span>
      <a routerLink="/accounts-products/{{ product.appId }}/accounts/{{ businessId }}/details">
        {{ product.appName }}
        <ng-container *ngIf="product.quantity > 1">({{ product.quantity }})</ng-container>
      </a>
    </span>
  </li>
</ul>
